const navLinks = [
    { title: `Memy`, path: `/` },
    { title: `Tabele`, path: `/tables` },
    { title: `Mecze`, path: `/matches` },
    { title: `Komentujemy!`, path: `/livechat` }
  ];

export default navLinks;